import {
  showLoader,
  hideLoader,
  showErrorResponseModal
} from 'store/actions/commons';
import { saveGiftTable } from 'services/api/table';
import { getGiftTable } from 'services/giftTable';
import { decodeStorage, encodeStorageLatin } from 'functions/storageBase64';
import {
  fetchMyGiftsTablesSuccess,
  setGiftTable
} from 'store/actions/giftTable';
import { PROFILE_DATA, CURRENT_GIFT_TABLE } from 'constants/storage64';
import {
  SET_CURRENT_STEP,
  SET_SELECTED_EVENT_TYPE,
  RESET,
  SAVE_GIFT_TABLE,
  SAVE_GIFT_TABLE_SUCCESS,
  SAVE_GIFT_TABLE_FAILED
} from './types';

export const resetGitTableFlow = () => ({
  type: RESET,
  payload: true
});

export const setCurrentStep = (payload) => ({
  type: SET_CURRENT_STEP,
  payload
});

export const setSelectedEventType = (payload) => ({
  type: SET_SELECTED_EVENT_TYPE,
  payload
});

export const saveGiftTableSuccess = (payload) => ({
  type: SAVE_GIFT_TABLE_SUCCESS,
  payload
});

export const saveGiftTableFailed = (payload) => ({
  type: SAVE_GIFT_TABLE_FAILED,
  payload
});

export const saveGiftTables =
  (payload, onSaveError) => async (dispatch, _, history) => {
    dispatch(showLoader());
    dispatch({ type: SAVE_GIFT_TABLE, payload });

    try {
      const giftTable = await saveGiftTable(payload, true);
      const profileData = decodeStorage(PROFILE_DATA);

      const params = {
        customer_sears_id: profileData ? profileData.idClaro : ''
      };

      const myGiftsTables = await getGiftTable(params);
      dispatch(fetchMyGiftsTablesSuccess(myGiftsTables));

      giftTable.evento = giftTable.id;

      dispatch(setGiftTable(giftTable));

      encodeStorageLatin(CURRENT_GIFT_TABLE, giftTable);

      dispatch(saveGiftTableSuccess(giftTable));
      history.push('/gracias');
    } catch (error) {
      const { response } = error;
      const statusCode = response?.status
      const message = response?.data?.data[0]
      let respMessage

      if(statusCode === 400 && message === 'There is already another open event like this.'){
        respMessage = '¡Oops! Ya tienes un evento similar en curso. No puedes crear otro igual'
      }else{
        respMessage = 'Error al guardar datos, inténtalo de nuevo'
      }

      dispatch(
        showErrorResponseModal({
          message: respMessage,
          title: 'Error',
          callback: onSaveError
        })
      );
      dispatch(saveGiftTableFailed(error));
      dispatch(hideLoader());
    } finally {
      dispatch(hideLoader());
    }
  };
